//评估api
//http://118.25.139.136:9184/swagger-ui.html#/estimate45controller

import request from '@/util/request'

//新建评估
export function apiNewEvaluation(data){
	return request({
		url: `/evaluation-s/estimate/detailedReport`,
		method:"post",
		data
	});
}
//编辑评估
export function apiEditEvaluation(data){
	return request({
		url: `/evaluation-s/estimate/detailedReport`,
		method:"put",
		data
	});
}
//评估列表
export function evaluationList(data){
	return request({
		url:`/evaluation-s/estimate/list`,
		method:'post',
		// dataType: 'json',
		data
	})
}
//删除评估
export function del(data) {
	return request({
		url: `/evaluation-s/estimate/batchDelete`,
		method: 'post',
		data: data
	})
}
//查询列表
export function evaluationDetail(id){
	return request({
		url:`/evaluation-s/estimate/${id}`,
		method:'get'
	})
}
//获取辐照数据
export function apiGetIrradiationData(data){
	return request({
		url:`/evaluation-s/cgi-bin/v1/DataAccess.py`,
		method:'get',
		params:data
	})
}



// WEBPACK FOOTER //
// ./src/api/bench/evaluation.js